/**
 * Autocomplete management for edit mode textareas
 */

import { apiGet } from '../utils/apiClient.js';
import { initAutocomplete, destroyAutocomplete } from '../autocomplete.js';
import { flattenRoles } from './utils.js';
import type { CirclePackNode } from '../../shared/types.js';

// Track autocomplete instances
let activeAutocompleteInstances: HTMLTextAreaElement[] = [];

/**
 * Initialize autocomplete on all editable textareas
 */
export async function initEditModeAutocomplete(): Promise<void> {
    try {
        // Fetch all roles for autocomplete
        const roles = await apiGet<CirclePackNode | CirclePackNode[]>('/api/roles');
        const flatRoles = flattenRoles(roles);
        
        // Find all textareas in edit mode (purpose field + list items + new item fields)
        const textareas = document.querySelectorAll('textarea#edit-purpose, textarea.list-item-input, textarea.new-item-textarea') as NodeListOf<HTMLTextAreaElement>;
        
        textareas.forEach(textarea => {
            initAutocomplete(textarea, flatRoles);
            activeAutocompleteInstances.push(textarea);
        });
    } catch (error) {
        console.error('Failed to initialize autocomplete:', error);
    }
}

/**
 * Cleanup all autocomplete instances
 */
export function cleanupEditModeAutocomplete(): void {
    activeAutocompleteInstances.forEach(() => {
        destroyAutocomplete();
    });
    activeAutocompleteInstances = [];
}
